import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { DOCUMENTS_BASE_PATH } from '../../constants/documentsBasePath';
import { getDocumentStatusAllGroupings } from '../../requests/getDocumentStatusAllGroupings';
import { DocumentParams } from '../../types/DocumentParams';

export const useDocumentStatusAllGroupings = (
  documentParams: DocumentParams,
  documentId: string,
) => {
  const { constructGet } = useRequestConstructor();

  const queryKey = [
    DOCUMENTS_BASE_PATH,
    'status',
    documentId,
    documentParams.definition,
    'grouping',
  ];

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocumentStatusAllGroupings>>
  >({
    queryKey,
    queryFn: async () =>
      getDocumentStatusAllGroupings(constructGet, documentParams, documentId),
    enabled: Boolean(documentId && documentParams.definition),
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(
      data,
      refetch,
      'documentStatusAllGroupings',
    ),
    ...rest,
  };
};
